import { Message } from '../types';

/**
 * Update message state when stopping a response
 * @param messages Current message list
 * @returns Updated message list
 */
export const handleMessageStop = (messages: Message[]): Message[] => {
  const lastMessage = messages[messages.length - 1];
  if (lastMessage && lastMessage.isBot) {
    return [...messages.slice(0, -1), { ...lastMessage, stopped: true }];
  }
  return messages;
};

/**
 * Create an abortable Promise for handling response timeouts
 * @param timeoutMs Timeout duration in milliseconds
 * @param abortSignal Signal from AbortController
 * @returns Promise that can be aborted
 */
export const createAbortableTimeout = (timeoutMs: number, abortSignal: AbortSignal): Promise<void> => {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(resolve, timeoutMs);
    abortSignal.addEventListener('abort', () => {
      clearTimeout(timeoutId);
      reject(new Error('Response stopped by user'));
    });
  });
};
